import React,{Fragment} from "react";
import {
  Route,
  Routes,
  BrowserRouter as Router,
  Redirect,
  Switch
} from "react-router-dom";

import Login from "../pages/auth/Login";
import Signup from "../pages/auth/Signup";
import DashboardLayout from "../layout/index";
import Dashboard from "../views/DashboardView";
import PasswordReset from '../pages/auth/PasswordReset'
import ResetPassword from '../pages/auth/ResetPassword'
import ExpirationVerification from '../pages/auth/ExpirationVerification'
import EmailConfirmation from "../pages/auth/EmailConfirmation";
import EmailSuccessPage from "../pages/EmailSuccessPage";
import PhoneNumberSuccessPage from "../pages/PhoneNumberSuccessPage";
import CompleteInvite from "../pages/CompleteInvite"
import ActivityUserCompleteRegistration from "../pages/ActivityUserCompleteRegistration"
import Cookies from "js-cookie";
import FAQPage from "../views/FaQ";
import UploadPage from "../components/Upload";
import TwoFALogin from "../components/Forms/TwoFALogin"
import Support from "../pages/Support"

export function PrivateRoute({ component: Component, ...rest }) {
  const token = Cookies.get("token");
  
  return (
    <Route
      {...rest}
      render={(props) => {
        return token ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        );
      }}
    />
  );
}



// export const PublicRoute = ({ component: Component, ...rest }) => {
//   let isLoggedIn = localStorage.token ? true : false;
//  console.log(isLoggedIn)
//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         isLoggedIn ? (
//           <Redirect to="/admin/dashboard" />
//         ) : (
//           <Component {...props} />
//         )
//       }
//     />
//   );
// };

export const Content = () => {
  return (
    <Router>
      <Switch>
        <PrivateRoute path="/admin" component={DashboardLayout} />
       
        <Route path="/signup" component={Signup} />
        <Route path="/confirmation" component={EmailConfirmation} />
        {/* <Route path="/upload-farmers" component={UploadPage} /> */}
        <Route path="/expiration" component={ExpirationVerification} />
        <Route path="/forgot-password" component={PasswordReset} />
        <Route path="/reset-password/:id" component={ResetPassword} />
        <Route path="/complete-invite/:user_id" component={CompleteInvite} />
        <Route path="/activity-user/complete-managed-invite/:token" component={ActivityUserCompleteRegistration} />
        <Route path="/email-success" component={EmailSuccessPage} />
        <Route path="/phonenumber-success" component={PhoneNumberSuccessPage} />
        <Route path="/2fa" component={TwoFALogin} />
        <Route path="/support" component={Support} />
        <Route path="/"  component={Login} />
       
        {/* <Redirect to="/404" /> */}
      </Switch>
    </Router>
  );
};
